<template>
  <div class="col-12 p-0 comments">
    <new-comment :postID="postID" @reloadComments="reloadComments" />
    <comments ref="comments" :postID="postID" :commentsArray="commentsArray"/>
  </div>
</template>

<script>
import NewComment from './New/NewComment'
import Comments from './Comments/Container'

export default {
  props: {
    postID: {
      required: true
    },
    commentsArray: {
      required: false
    }
  },
  components: {
    'new-comment': NewComment,
    'comments': Comments
  },
  methods: {
    reloadComments: function ( pg ) {
      this.$refs.comments.reload(1, false, pg)
    }
  }
}
</script>
